export type CurrencyCode = 'AUD'

export interface CeramicPackage {
  id: string
  slug: string
  displayName: string
  productName: string
  description: string
  durabilityLabel: string
  startingPriceCents: number
  currency: CurrencyCode
  badge?: string
  warrantyEligible: boolean
  warrantyLabel?: string
  optionalUpgrade?: string
  featured?: boolean
  active: boolean
  cta: string
  estimatedDuration?: string
}

export interface SelectedProtection {
  id: string
  slug: string
  durationLabel: string
  productName: string
  durabilityLabel: string
  startingPriceCents: number
  currency: CurrencyCode
  warrantyEligible: boolean
}

export const ceramicPackages: CeramicPackage[] = [
  {
    id: 'cancoat-evo-1-year',
    slug: '1-year-protection',
    displayName: '1 Year Protection',
    productName: 'GYEON Q² CanCoat EVO',
    description:
      'An excellent introduction to ceramic protection, ideal for daily-driven vehicles looking for enhanced gloss, easier maintenance and lasting protection.',
    durabilityLabel: '12 Months+',
    startingPriceCents: 82500,
    currency: 'AUD',
    badge: 'Entry Protection',
    warrantyEligible: false,
    active: true,
    cta: 'Select 1 Year Protection',
    estimatedDuration: '1 day',
  },
  {
    id: 'flash-evo-3-year',
    slug: '3-year-protection',
    displayName: '3 Year Protection',
    productName: 'GYEON Q² Flash EVO',
    description:
      'A premium ceramic coating offering enhanced durability, exceptional gloss and long-term protection for vehicles that deserve more.',
    durabilityLabel: '3 Years+',
    startingPriceCents: 115000,
    currency: 'AUD',
    badge: 'Most Popular',
    warrantyEligible: true,
    warrantyLabel: 'Manufacturer-Backed Warranty Available',
    featured: true,
    active: true,
    cta: 'Select 3 Year Protection',
    estimatedDuration: '1-2 days',
  },
  {
    id: 'infinite-evo-5-year',
    slug: '5-year-protection',
    displayName: '5 Year Protection',
    productName: 'GYEON Q² Infinite EVO',
    description:
      'Our ultimate ceramic coating, delivering outstanding durability, exceptional gloss and the highest level of long-term paint protection.',
    durabilityLabel: '5 Years+',
    startingPriceCents: 165000,
    currency: 'AUD',
    badge: 'Ultimate Protection',
    warrantyEligible: true,
    warrantyLabel: 'Manufacturer-Backed Warranty Available',
    optionalUpgrade: 'Optional GYEON Infinite Top Coat Upgrade',
    active: true,
    cta: 'Select 5 Year Protection',
    estimatedDuration: '2-3 days',
  },
]

export const coatingIncludes = [
  'Safe hand wash',
  'Chemical decontamination',
  'Professional paint preparation',
  'GYEON ceramic coating application',
  'Aftercare advice',
  'Complimentary vehicle inspection',
]

export const warrantyInformation = {
  heading: 'Warranty Information',
  copy: 'GYEON Flash EVO and GYEON Infinite EVO are eligible for a manufacturer-backed warranty when installed by a GYEON Certified Detailer and maintained in accordance with GYEON’s warranty requirements.',
}

export function formatCurrencyFromCents(cents: number, currency: CurrencyCode = 'AUD') {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(cents / 100)
}

export function getCeramicPackage(packageId?: string) {
  return ceramicPackages.find((item) => item.id === packageId)
    ?? ceramicPackages.find((item) => item.featured)
    ?? ceramicPackages[0]
}

export function findCeramicPackage(packages: CeramicPackage[], packageId?: string | null) {
  if (!packageId) return undefined
  return packages.find((item) => item.id === packageId || item.slug === packageId)
}
